// extracted by mini-css-extract-plugin
export default {"editForm":"ActiveBooking_editForm__aX+fx"};